var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36.8 31.3",
    style: {
      enableBackground: "new 0 0 36.8 31.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30.5c-2.5,0-4.7-1.2-6.5-3.5c-1.8-2.3-2.7-5.3-2.7-9c0-4.3,1.3-8.1,3.8-11.1c2.5-3.1,6.1-5.1,10.6-6l0.6-0.1v3.9 l-0.4,0.1c-6.9,1.3-10.2,5.1-10.2,11.4c0,3,1.1,3,1.5,3c0.2,0,0.6-0.1,1-0.2c0.9-0.3,1.7-0.4,2.3-0.4c1.9,0,3.5,0.6,4.6,1.9 c1.1,1.2,1.7,2.6,1.7,4.2c0,1.6-0.6,3-1.8,4.2C33.1,29.9,31.6,30.5,29.7,30.5z M9.9,30.5c-2.5,0-4.7-1.2-6.5-3.5 c-1.8-2.3-2.7-5.3-2.7-9.1c0-4.3,1.3-8.1,3.8-11.1c2.5-3.1,6-5.1,10.6-6l0.6-0.1v3.9l-0.4,0.1C8.3,6.1,5,9.8,5,16.1c0,3,1.2,3,1.6,3 c0.2,0,0.6-0.1,1-0.2c0.9-0.3,1.6-0.4,2.3-0.4c1.9,0,3.5,0.6,4.6,1.9c1.1,1.2,1.7,2.6,1.7,4.2c0,1.6-0.6,3-1.8,4.2 C13.3,29.9,11.8,30.5,9.9,30.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.d149e7ca.svg";
export { ForwardRef as ReactComponent };